import React, { useEffect, useState } from 'react'

import InputWrapper from '../InputWrapper/InputWrapper'

import { NumericTextboxProps } from './NumericTextbox.types'
import useInput from '../useInput'

const NumericTextbox: React.FC<NumericTextboxProps> = (props) => {
    const { decimals = 0, enforceNegative =false,min, max, factor, format, prepend, append, placeholder } = props
    const _factor = factor || (format === 'p' ? 100 : null)
    const _decimals = decimals
    const context = useInput(props, 'number')
    const [isNegative, setIsNegative] = useState(enforceNegative)
    const [internalVal, setInternalVal] = useState<number>(context.value)
    const [isMounted, setIsMounted] = useState(false)

    const getPrepend = () => {
        if (prepend !== undefined) {
            return prepend
        }
        if (isNaN(context.value)) {
            return ''
        }
        if (format === 'c') {
            return '$'
        }
        return ''
    }

    const getAppend = () => {
        if (isNaN(context.value)) {
            return ''
        }

        if (append !== undefined) {
            return append
        }
        if (format && format === 'p') {
            return '%'
        }
        return ''
    }
    const renderValue = () => {
        let v = context.value || placeholder || 0

        if (_factor) {
            v = v * _factor
        }

        v = v.toLocaleString('en-US', {
            minimumFractionDigits: _decimals,
            maximumFractionDigits: _decimals,
        })

        return v
    }

    const convertToNumber = (val) => {
        let _value = val
        if (_decimals !== 0) {
            _value = parseFloat(_value)
        } else {
            _value = parseInt(_value)
        }

        if (isNaN(_value)) {
            return null
        }

        if (_factor) {
            // _value = _value / _factor
        }

        return _value
    }

    const handleChange = (context) => (e) => {
        let val = e.target.value
        const currentValue = context.value
        if (context.isDisabled) {
            return
        }
        const invalidChars = ['e', 'E']
        if (isNaN(val) || invalidChars.indexOf(e.nativeEvent.data) !== -1) {
            return
        }

        //Convert number to negative when the '-' key is pressed
        if (e.nativeEvent.data === '-') {
          if(!enforceNegative){
            setIsNegative(!isNegative)
          }
            return
        }

        // If empty string set value to null
        if (val === '') {
            // context.onChange(null)
          setInternalVal(0)
            return
        }

        if (_decimals !== 0 && val) {
            const valSplit = val.toString().split('.')
            if (valSplit[1]) {
                val = parseFloat(val).toFixed(_decimals)
            }
        } else {
            val = Math.trunc(val)
        }

        let num = convertToNumber(val)

        if (_factor) {
            num = num / _factor
        }
        if (isNegative) {
            num = -Math.abs(num)
        }

        setInternalVal(num)
        // context.onChange(num)
    }

    const handleBlur = (context) => (e) => {
        const { value } = context
        let minMaxBoundValue = value
        context.onBlur(context)

        if (isNegative) {
            minMaxBoundValue = -Math.abs(value)
        }

        if (_factor) {
            // minMaxBoundValue = minMaxBoundValue / _factor
        }

        if (min !== undefined && value < min) {
            minMaxBoundValue = min
        }
        if (max !== undefined && value > max) {
            minMaxBoundValue = max
        }

        if (minMaxBoundValue !== value) {
            setInternalVal(minMaxBoundValue)
        }
    }

    let displayValue = `${getPrepend()}${renderValue()}${getAppend()}`

    if (context.value === null || context.value === undefined) {
        displayValue = null
    }

    let val = context.value

    if (_factor && context.isFocused) {
        val = _factor * val
    }

    useEffect(() => {
        context.onChange(internalVal)
    }, [internalVal])

    useEffect(() => {
      setIsMounted(true)
    }, [])

    useEffect(() => {
      if(isMounted){
        setInternalVal(internalVal * -1)
      }
    }, [isNegative])

    return (
        <InputWrapper {...context} displayValue={displayValue}>
          <div className={"r-input-numeric-wrapper"}>
            {context.isFocused ? (
              <input
                autoFocus
                type={'number'}
                onFocus={() => {
                  context.onFocus()
                }}
                placeholder={props.placeholder || ''}
                disabled={context.isDisabled}
                data-testid='NumericTextbox'
                className={'r-numeric-textbox r-input-base'}
                value={val !== null ? val : isNegative ? -0 : ''}
                onChange={handleChange(context)}
                onBlur={handleBlur(context)}
              />
            ) : (
              <input
                onFocus={() => {
                  context.onFocus()
                }}
                onChange={() => {}}
                placeholder={props.placeholder || ''}
                disabled={context.isDisabled}
                data-testid='NumericTextbox'
                className={'r-textbox r-input-base'}
                value={displayValue}
              />
              // <div
              //     className={'r-input-base'}
              //     onClick={() => {
              //         if (context.isDisabled) {
              //             return
              //         }
              //         context.onFocus()
              //     }}
              // >
              //     {displayValue}
              // </div>
            )}
          </div>
        </InputWrapper>
    )
}

export default NumericTextbox
